import WatercourseAPI from '../api/watercourse.js';

export const watercourses = {
  state: {
    /* 
       status = 0 -> No loading has begun
       status = 1 -> Loading has started
       status = 2 -> Loading completed successfully
       status = 3 -> Loading completed unsuccessfully
        */

    watercourses: [],
    watercoursesLoadStatus: 0,

    watercourse: {},
    watercourseLoadStatus: 0,

    view: 'kvalitetsnorm'
  },
  actions: {
    loadWatercourses({ commit }) {
      commit('setWatercoursesLoadStatus', 1);
      WatercourseAPI.getWatercourses()
        .then(function(response) {
          commit('setWatercourses', response.data);
          commit('setWatercoursesLoadStatus', 2);
        })
        .catch(function() {
          commit('setWatercourses', []);
          commit('setWatercoursesLoadStatus', 3);
        });
    },
    loadWatercourse({ commit }, data) {
      commit('setWatercourseLoadStatus', 1);

      WatercourseAPI.getWatercourse(data.id)
        .then(function(response) {
          commit('setWatercourse', response.data);
          commit('setWatercourseLoadStatus', 2);
        })
        .catch(function() {
          commit('setWatercourse', {});
          commit('setWatercourseLoadStatus', 3);
        });
    },
    // updateView({ commit }, data) {
    //   commit('setView', data.view);
    // }
  },
  mutations: {
    setWatercoursesLoadStatus(state, status) {
      state.watercoursesLoadStatus = status;
    },

    setWatercourses(state, watercourses) {
      state.watercourses = watercourses;
    },

    setWatercourseLoadStatus(state, status) {
      state.watercourseLoadStatus = status;
    },

    setWatercourse(state, watercourse) {
      state.watercourse = watercourse;
    },
    // setView(state, view) {
    //   state.view = view;
    // }
  },
  getters: {
    getWatercoursesLoadStatus(state) {
      return state.watercoursesLoadStatus;
    },

    getWatercourses(state) {
      return state.watercourses;
    },

    getWatercourseLoadStatus(state) {
      return state.watercourseLoadStatus;
    },

    getWatercourse(state) {
      return state.watercourse;
    },

    // getView(state) {
    //   return state.view;
    // }
  }
};
